module.exports = __webpack_public_path__ + "static/media/logout-sidebar.6bcb140e.svg";